import { render, staticRenderFns } from "./TrailerChartsItem.vue?vue&type=template&id=bfb7d5a0&scoped=true"
import script from "./TrailerChartsItem.vue?vue&type=script&lang=js"
export * from "./TrailerChartsItem.vue?vue&type=script&lang=js"
import style0 from "./TrailerChartsItem.vue?vue&type=style&index=0&id=bfb7d5a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb7d5a0",
  null
  
)

export default component.exports